import { TimeStringHelper } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { Poker2ChatEvent } from "../../../event/Poker2ChatEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { TableChatHelper } from "../../../view/helper/TableChatHelper";
import { Poker2Command } from "../Poker2Command";

export class CPUCommand extends Poker2Command {
    protected get cmdId(): string {
        return "cpu";
    }

    public executeCommand(error: number, params: any[]): boolean {
        params.shift();
        var muteTime: number = params.shift();
        var muteTimeString: string = TimeStringHelper.getTimeToString(muteTime * 60, TimeStringHelper.TWO_TIME_FORMAT, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        var badwords: string = params.shift();
        var warningMsg: string;
        switch (error) {
            case 1:
                warningMsg = Poker2Model.languageData.getTextById("generic_report_muted_badword2_copy", [muteTimeString, badwords]);
                break;
            case 2:
                if (muteTime == 0)
                    warningMsg = Poker2Model.languageData.getTextById("generic_report_reported_copy", [badwords]);
                else
                    warningMsg = Poker2Model.languageData.getTextById("generic_report_muted_reported_copy", [muteTimeString, badwords]);
                break;
            case 3:
                warningMsg = Poker2Model.languageData.getTextById("generic_report_muted_badword1_copy", [badwords]);
                break;
            case 4:
                warningMsg = Poker2Model.languageData.getTextById("generic_report_muted_domain1");
                break;

        }
        this.controller.dispatchEvent(new Poker2ChatEvent("addmsg", TableChatHelper.ADMIN_MSG, TableChatHelper.ADMIN_MSG, warningMsg, "", false, false));
        return true;

    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
